function SharedWishlistFactory(container) {
  class SharedWishlist {
    constructor(container, customerEmail, customerFirstName, customerLastName) {
      this.wishlistWidget = container;
      this.wishlistApp = null;
      this.queryParams = null;

      this._init();
    }
    appendHtml(selector, htmlContent, position = "beforeend") {
      const div = selector;
      if (div) {
        div.insertAdjacentHTML(position, htmlContent);
      } else {
        console.warn(`Element with selector "${selector}" not found.`);
      }
    }

    _init() {
      this._renderSharedWishlistPage();
    }
    _setEvents() {}
    async _renderwishlistProducts(product_handle) {
      if (!product_handle) return;

      let productCard = new ProductCardJS();
      let productCardDetails = await productCard._fetchProductCard(
        product_handle
      );

      return productCardDetails;
    }
    async _onFetchListDetailsSuccess(listDetails) {
      // Successfully fetched list details

      console.log("Successfully fetched List details", listDetails);
      let wishlistPageContent = ``;

      // debugger;
      wishlistPageContent += `
        <div class="wishlist-details__header">
          <h1 class="wishlist-details__header--title">
            ${listDetails.list.lname}
          </h1>
          <p class="wishlist-details__header--subtitle">
            ${window.themeVariables.translations.wishlist.wishlistPageSubtitle}
          </p>
        </div>
        <product-list class="product-list" role="region" aria-live="polite">
        ${(
          await Promise.all(
            listDetails.items.map(async (product) => {
              return await this._renderwishlistProducts(
                product.du.split("products/").pop()
              );
            })
          )
        ).join("")}
        </product-list>
      `;
      this.wishlistWidget.innerHTML = wishlistPageContent;
    }
    _onFetchListDetailsError(error) {
      debugger; // Error is an xhrObject
      console.log("Error while fetching List details", error);
    }

    _renderSharedWishlistPage() {
      let $this = this;
      window.SwymCallbacks = window.SwymCallbacks || [];
      window.SwymCallbacks.push(function (swat) {
        this.wishlistApp = swat;
        this.queryParams = this.wishlistApp.utils.getEncodedAsObject(
          window.location.search
        );

        // define the list config
        let listConfig = {
          // lid: '59179e9f-139d-4857-bcdd-3ad88a38b47d', // lid
          lid: this.queryParams["lid"],
        };

        let onSuccess = (listDetails) => {
          // Call the success callback with the list details
          $this._onFetchListDetailsSuccess(listDetails);
        };
        let onError = (error) => {
          // Call the success callback with the list details
          $this._onFetchListDetailsSuccess(error);
        };
        // Call `fetchListDetails` with the above callbacks and listConfig
        this.wishlistApp.fetchListDetails(listConfig, onSuccess, onError);
      });
    }
  }
  return new SharedWishlist(container);
}
